import clsx from 'clsx';

/**
 * Chains multiple functions into a single one that calls each in order.
 */
function chain(...callbacks) {
  return (...args) => {
    for (const callback of callbacks) {
      if (typeof callback === 'function') {
        callback(...args);
      }
    }
  };
}

/**
 * Merges multiple sets of props:
 * - Chains event handlers (onClick, onChange, etc.)
 * - Merges className using `clsx`
 * - For all other keys, last value wins
 */
export function mergeProps(...args) {
  const result = { ...args[0] };

  for (let i = 1; i < args.length; i++) {
    const props = args[i];
    if (!props) continue;

    for (const key in props) {
      const a = result[key];
      const b = props[key];

      // Chain event handlers like onClick, onChange, etc.
      if (
        typeof a === 'function' &&
        typeof b === 'function' &&
        key.startsWith('on') &&
        key[2] && key[2] === key[2].toUpperCase()
      ) {
        result[key] = chain(a, b);

      // Merge class names
      } else if (
        (key === 'className' || key === 'UNSAFE_className') &&
        typeof a === 'string' &&
        typeof b === 'string'
      ) {
        result[key] = clsx(a, b);

      } else {
        result[key] = b !== undefined ? b : a;
      }
    }
  }

  return result;
}
